import Cookie from 'js-cookie'

import { SHWError } from '@/common/error'
import logger from '@/utils/logger'

import { COOKIE_PRIMARY_INTEREST } from '@/client/settings'

import { type PrimaryInterestV2, PrimaryInterestV2Schema } from './types'

/**
 * Sets the primary interest for the user as a cookie (client-side only)
 * @param interest The primary interest object
 */
export function setPrimaryInterestCookie(interest: PrimaryInterestV2): void {
  const parseResult = PrimaryInterestV2Schema.safeParse(interest)

  if (!parseResult.success) {
    logger.error('Invalid primary interest', { interest })
    throw new SHWError({
      internalMessage: 'Invalid primary interest',
    })
  }

  const interestJson = JSON.stringify(parseResult.data)

  // Set a cookie so the server can read it during Auth0 callback
  Cookie.set(COOKIE_PRIMARY_INTEREST, interestJson, {
    expires: 7, // expire in 7 days
    path: '/',
  })
}
